import { withCompInfo } from '@wix/editor-elements-integrations'
import { TinyMenuCSSVars, TinyMenuDefinition } from './TinyMenu'
import { colorApi } from '@wix/thunderbolt-becky-root'

const WIX_ADS_HEIGHT = 38

const isClassicSkin = (skin: TinyMenuDefinition['skin']) => skin === 'TinyMenuSkin'

export const css = withCompInfo<TinyMenuCSSVars, TinyMenuDefinition>()(
	// @ts-ignore - remove once siteWidth is added to CompInfo
	['compLayout', 'styleProperties', 'skin', 'siteWidth', 'siteColors', 'shouldShowFreemiumBanner'],
	// @ts-ignore - remove once siteWidth is added to CompInfo
	({ compLayout, styleProperties, skin, siteWidth, siteColors, shouldShowFreemiumBanner }) => {
		const isFixedPosition = compLayout.fixedPosition
		const strokeWidth = styleProperties.strokewidth
		const xPosition = compLayout.x
		const yPosition = compLayout.y

		const btnPaddingTop = strokeWidth && {
			'--btn-padding-top': `${((parseInt(strokeWidth, 10) % 2) * -1 + 1) / 2}px`,
		}

		const buttonMarginTop = isFixedPosition &&
			shouldShowFreemiumBanner && {
				'--btn-margin-top': `${WIX_ADS_HEIGHT}px`,
			}

		const containerPaddingTop = shouldShowFreemiumBanner && {
			'--container-padding-top': `${WIX_ADS_HEIGHT}px`,
		}

		const rootStyles = isFixedPosition && {
			'margin-left': `calc(50% - ${siteWidth ? siteWidth / 2 : 0}px)`,
			position: 'fixed',
			'--top': `${yPosition}px`,
			left: `${xPosition}px`,
			'--root-z-index': 50,
		}

		const brightnessParams = colorApi.getBrightnessCSSVars<
			Pick<TinyMenuCSSVars, '--counter-color-mutated-brightness'>
		>({
			paramName: 'counterColor',
			mutatedParamName: 'counter-color',
			fallbackName: 'txt',
			alpha: 2,
			siteColors,
			styleProperties,
		})

		const containerMarginLeft = isClassicSkin(skin) && {
			'--container-margin-left': `${xPosition ? `-${xPosition}px` : 0}`,
		}

		const fixInvalidBg = styleProperties.bg === '###' && {
			'--bg': 'var(--color_15)',
		}

		return {
			...brightnessParams,
			...btnPaddingTop,
			...buttonMarginTop,
			...containerPaddingTop,
			...containerMarginLeft,
			...rootStyles,
			...fixInvalidBg,
		}
	}
)
